// src/components/Footer.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Flex, Text, View } from '@aws-amplify/ui-react';
import './Footer.css';

const Footer: React.FC = () => {
    return (
        <footer className="footer cinematic-footer">
            <Flex
                direction={{ base: 'column', medium: 'row' }}
                justifyContent="space-between"
                alignItems="center"
                maxWidth="1200px"
                margin="0 auto"
                padding="2rem"
                gap="1rem"
            >
                {/* Logo */}
                <Text className="logo-text" color="white" fontWeight="bold" fontSize="1.25rem">
                    BANJARA
                </Text>

                {/* Navigation Links */}
                <Flex gap="2rem">
                    <a href="mailto:support@banjara-app.com" className="footer-link">Support</a>
                    <Link to="/privacy-policy" className="footer-link">Privacy</Link>
                    <Link to="/terms-of-use" className="footer-link">Terms</Link>
                </Flex>

                {/* Copyright */}
                <Text fontSize="0.875rem" color="#777777">
                    © 2025 Banjara. All rights reserved.
                </Text>
            </Flex>

        </footer>
    );
};

export default Footer;